import { ProcedureFieldValuesAttachmentService as OvermapProcedureFieldValuesAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureFieldValuesAttachmentService extends OvermapProcedureFieldValuesAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
